import { Popover, VStack, HStack, Box, Text, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { FilterPopoverButton, FilterPopoverContent } from './FilterPopover';
import { COMMENT_STATUS } from '@/shared/constants';
import { ICourse } from '@/shared/ICourse';
import { CommentsService } from '@/app/services/CommentsService';

export const CheckboxFilterComments = (props: {
  allCourses: ICourse[];
  value: string[] | undefined;
  onSetFilter: (value: string[] | undefined) => void;
}) => {

  const options = [
    COMMENT_STATUS.COMMENT, 
    COMMENT_STATUS.ACTION_REQUIRED, 
    COMMENT_STATUS.RESOLVED, 
    COMMENT_STATUS.REOPENED
  ]
    .map((status) => ({
      label: CommentsService.getCommentStatusText(status),
      value: status,
      color: CommentsService.getCommentStatusColor(status),
      count: props.allCourses?.reduce((count, course) => {
        const commentCount = CommentsService.getQuestionCommentCount(
          course.commentSet, 
          comment => (comment.status || COMMENT_STATUS.COMMENT) === status
        );
        return commentCount > 0 ? count + 1 : count;
      }, 0)
    }))
    .filter(option => option.count > 0); // Only show options that exist

  const hasSelection = (props.value?.length || 0) > 0;

  return (
    <Popover isLazy placement="bottom-start">
      <FilterPopoverButton label="Comments" selected={hasSelection} />
      <FilterPopoverContent>
        <CheckboxGroup value={props.value || []} onChange={(v) => props.onSetFilter(v.length > 0 ? v as string[] : undefined)}>
            <VStack spacing="2" align="stretch">
              {options.map((option) => (
                <Checkbox key={option.value} value={option.value} colorScheme="blue">
                  <HStack spacing="1" align="center" width="full">
                    <Box
                      width="12px"
                      height="12px"
                      borderRadius="2px"
                      bg={`${option.color}.200`}
                      border="1px solid"
                      borderColor={`${option.color}.400`}
                      flexShrink={0}
                    />
                    <Text fontSize="sm" flex="1">
                      {option.label}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      ({option.count})
                    </Text>
                  </HStack>
                </Checkbox>
              ))}
            </VStack>
          </CheckboxGroup>
        </FilterPopoverContent>
    </Popover>
  );
};
